<template>
  <div class="card" @click.prevent="goToNotification">
    <div class="card-body">
      <div class="row">
        <!-- Left column -->
        <div class="col-md-8">

          <div class="ticket-card-left-wrapper">
            <div class="left">
              <div class="avatar-sm">
              <span class="avatar-title rounded bg-soft-primary text-primary font-size-16">
              <i class="bx bx-bell"></i>
              </span>
              </div>
            </div>
            <div class="right">
              <div>
                <b class="subject">{{ notification.data.subject }}</b><br>
                <div class="property mt-1">
                  <span>Created:</span> {{ displayTimeAgo(notification.created_at) }}
                </div>
                <div class="property mt-1">
                  <span>Read:</span> {{ notification.read_at ? displayTimeAgo(notification.read_at) : '-' }}
                </div>
                <div class="property mt-1">
                  {{ notification.data.body }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- / Left column -->

        <!-- Right column -->
        <div class="col-md-4 right-properties">
          <div class="property">
            <span v-if="!notification.read_at"
                class="badge badge-danger font-size-12 px-3 py-2">Unread</span>
          </div>
        </div>
        <!-- / Right column -->
      </div>
    </div>
  </div>
</template>

<script>
import Dates from "../../../../mixins/Dates";

export default {
  name: "NotificationCard",
  props: ['notification'],
  mixins: [Dates],
  methods: {
    goToNotification() {
      this.$router.push(this.notification.data.url);
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-half {
  margin-top: 0.125rem !important;
}

.card {
  transition: box-shadow 0.2s ease-in-out;
  cursor: pointer;
  margin-bottom: 0.75rem;

  &:hover {
    box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 7%) !important;
  }
}

.card-body {
  padding: 0.9rem 1rem;
}

.property {
  font-size: 11px;

  span {
    font-weight: 500;
    margin-right: 5px;
  }
}

.ticket-card-left-wrapper {
  display: flex;

  .left {
    flex-shrink: 1;
    width: 70px;
    align-items: center;
    display: flex;
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }

  .subject {
    font-weight: 600;
    color: #2c5cc5;
  }
}

.right-properties {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
</style>